import { RefObject } from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';

export function useIsVisible<TElement extends Element>(
  ref: RefObject<TElement>
): boolean {
  return useIntersectionObserver(ref);
}

export function useHasBeenVisibleOnce<TElement extends Element>(
  ref: RefObject<TElement>
): boolean {
  return useIntersectionObserver(ref, {
    freezeOnceVisible: true,
  });
}
